<template>
  <div class="forgetpassword">
    <el-row class="forgetpassword-container">
      <el-col :span="18" style="height: 100%">
        <img class="logo-pic" src="../../../../common/img/loginBg.png">
        <div class="login_bgimg_title">{{ $t('welcome_to_iceq') }}</div>
        <div class="login_bgimg_subtitle">{{ $t('tenant_system') }}</div>
      </el-col>
      <el-col :span="6" class="login-form1">
        <div style="height:5%"></div>
        <div>
          <img style="width:auto;height:100px;" src="../../assets/img/logo-icon.png" />
        </div>
        <div style="height:5%"></div>
        <el-form :model="form" ref="form" style="width: 68%;margin:0 auto;">
          <!-- <i class="iconfont icon-logo"></i> -->
          <el-form-item style="text-align: left;">
            <template>
              <el-row>
                <el-col :span="24" style="text-align:center">
                  <div class="forget_password_tit">{{ $t('forget_password') }}</div>
                </el-col>
              </el-row>
            </template>
          </el-form-item>
          <div v-if="forgetPasswordTips">
            <el-form-item>
              <label class="el-form-item__label el-form-item__label_login" slot="label" style="">{{ $t('email')
                }}</label>
              <el-input type="text" class="common-input" v-model="form.email" autocomplete="off"></el-input>
            </el-form-item>
            <div class="pic" @click="changeCodeImg()">
              <i class="el-icon-refresh"></i>
              <img :src="form.codeImg">
            </div>
            <el-form-item>
              <label class="el-form-item__label el-form-item__label_login" slot="label" style="">{{
                $t('enter_character')
                }}</label>
              <el-input type="text" class="common-input" v-model="form.VerificationCode" autocomplete="off"></el-input>
            </el-form-item>
          </div>
          <div v-else>
            <div class="registered-title">{{ $t('reset_password') + ' ' + form.email + ' ' + $t('please_email') }}</div>
          </div>
          <el-form-item>
            <el-button v-if="forgetPasswordTips" type="primary" round style="margin-top: 10px" class="common-input"
              @click="handleNextClick">{{ $t('next') }}</el-button>
            <el-button v-else type="primary" round style="margin-top: 30px" class="common-input"
              @click="handleSigninClick">{{
                $t('signIn') }}</el-button>
          </el-form-item>
          <div class="or_title">
            <span class="or-line"></span>
            <span style="margin: 0 29px;font-size: 14px;font-weight: bold;">{{ $t('or') }}</span>
            <span class="or-line"></span>
          </div>
          <el-form-item>
            <el-button v-if="forgetPasswordTips" type="default" round class="common-input" @click="handleSigninClick">{{
              $t('signIn') }}</el-button>
            <el-button v-else type="default" round class="common-input" @click="handleResendClick">{{ $t('resend')
              }}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import authInfoMgmt from '../../auth-info-mgmt-inst';
import i18nMgmt from '../../locale/i18n-mgmt-inst';

export default {
  name: 'forgetpassword',
  data() {
    return {
      languageOptions: [],
      forgetPasswordTips: true,
      form: {
        email: '',
        codeImg: '',
        language: '',
        VerificationCode: '',
        Otoken: ''
      }
    };
  },

  created() {
    this.changeCodeImg();
  },

  components: {},

  computed: {},

  mounted() {
    this.languageOptions = i18nMgmt.getLangList();
    this.form.language = i18nMgmt.getCurLang();
  },

  methods: {
    onLangChanged() {
      const loading = this.$loading();
      i18nMgmt.setLang(this.$i18n, this.form.language).then(() => {
        loading.close();
      });
    },
    handleNextClick() {
      authInfoMgmt
        .NextByEmail({
          email: this.form.email,
          captcha: this.form.VerificationCode,
          captchaToken: this.form.Otoken
        })
        .then((data) => {
          if (data.succeeded) {
            authInfoMgmt
              .SuccessDataUrlPic({
                code: this.form.VerificationCode,
                token: this.form.Otoken
              })
              .then((data) => {
                if (data.succeeded) {
                  this.forgetPasswordTips = false;
                  this.$message({
                    message: this.$t('new_password_toEmail'),
                    type: 'success',
                    duration: 5000
                  });
                } else if (data.reason === 1) {
                  this.$message({
                    message: this.$t('ver_code_error'),
                    type: 'warning',
                    duration: 5000
                  });
                } else if (data.reason === 2) {
                  this.$message({
                    message: this.$t('ver_code_exd'),
                    type: 'warning',
                    duration: 5000
                  });
                }
              });
          } else {
            if (data.reason === 1) {
              this.$message({
                message: this.$t('user_does_not_exist'),
                type: 'error',
                duration: 5000
              });
              this.changeCodeImg();
            }
          }
        });
    },
    changeCodeImg() {
      authInfoMgmt.DataUrlPic({}).then((data) => {
        this.form.Otoken = data.token;
        this.form.codeImg = data.dataUrl;
      });
    },
    handleSigninClick() {
      this.$router.push({
        name: 'Login'
      });
    },

    handleResendClick() {
      this.handleNextClick();
    }
  }
};
</script>
<style scoped lang="scss">
.login-form1 {
  background: #f4f4f4;
  height: 100%;
  position: relative;
  width: 25%;
  float: left;
  text-align: center;
}

.forgetpassword {
  width: 100vw;
  height: 100vh;

  &-container {
    height: 100%;
    width: 100%;
  }

  .el-form-item__label_login {
    font-size: 16px;
    font-weight: bold;
    color: #292929;
    padding-left: 16px;
    word-wrap: break-word;
    text-align: left;
  }

  .common-input {
    width: 100%;
    height: 40px;
  }
}

.login_bgimg {
  width: 722px;
  height: 568px;
  background: url('../../../../common/img/loginBg.png') no-repeat;
  margin: 150px auto 0;
}

// .login_logo {
//   color: #292929;
//   font-size: 96px;
//   font-weight: bold;
//   margin-bottom: 30px;
// }

.logingo {
  width: 100%;
  height: 100%;
  background: #f4f4f4;
}

.forget_password_tit {
  font-size: 34px;
  color: #292929;
  font-weight: bold;
}

.login_bgimg_title {
  color: #203556;
  font-weight: bold;
  font-size: 55px;
  line-height: 66px;
  letter-spacing: 1.44px;
}

.bg-purple {
  color: #333333;
  font-weight: bold;
  font-size: 16px;
}

.bg-purple-title {
  text-align: left;
  margin-left: 135px;
}

.forget_title {
  color: #2a2a2a;
  font-size: 12px;
  margin-top: 20px;
  cursor: pointer;
}

// .or_title {
//   color: #2a2a2a;
//   font-weight: bold;
//   font-size: 14px;
//   margin: 30px 0;
// }

.pic {
  position: relative;
  cursor: pointer;
}

.pic .el-icon-refresh {
  font-size: 20px;
  position: absolute;
  top: 3px;
  right: 5px;
}

.pic img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.registered-title {
  width: 100%;
  word-wrap: break-word;
  word-break: normal;
  margin: 15px 0 0 8px;
  text-align: left;
}

.login_bgimg_subtitle {
  font-size: 55px;
}
</style>